
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import type { Application } from '@/types/database.types';

interface BusinessOperationsProps {
  register: UseFormRegister<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
}

export const BusinessOperations = ({
  register,
  setValue,
  watch,
}: BusinessOperationsProps) => {
  return (
    <div className="space-y-6">
      {/* This component is now empty as all questions have been moved to RiskAssessment */}
    </div>
  );
};
